import { render, staticRenderFns } from "./PositionPopup.vue?vue&type=template&id=0de35997&scoped=true&"
import script from "./PositionPopup.vue?vue&type=script&lang=js&"
export * from "./PositionPopup.vue?vue&type=script&lang=js&"
import style0 from "./PositionPopup.vue?vue&type=style&index=0&id=0de35997&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0de35997",
  null
  
)

export default component.exports